"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { type ReactNode, useState } from "react";

import { ApiError } from "@/lib/api";

const isRetryableError = (error: unknown) =>
  !(error instanceof ApiError && error.status >= 400 && error.status < 500);

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5, // dados ficam "frescos" por 5 min
            retry: (failureCount, error) => failureCount < 2 && isRetryableError(error),
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={true} buttonPosition="top-left" />
    </QueryClientProvider>
  );
}
